<div class="basket-item__info">
  @if (item().resourceName) {
    <span class="basket-item__resource">{{ item().resourceName }}</span>
  }
  @if (item().locationName) {
    <span class="basket-item__location">{{ item().locationName }}</span>
  }
  <div class="basket-item__time">
    @if (item().count > 1) {
      <span class="basket-item__count" aria-hidden="true">{{ item().count }}×</span>
    }
    <app-date-range-label [start]="item().start" [end]="item().end" />
    @if (isOngoing()) {
      <mat-chip-set class="basket-item__chips" aria-label="Status">
        <mat-chip class="chip--ongoing">
          <mat-icon matChipAvatar>schedule</mat-icon>
          Igangværende
        </mat-chip>
      </mat-chip-set>
    } @else if (isExpired()) {
      <mat-chip-set class="basket-item__chips" aria-label="Status">
        <mat-chip class="chip--expired">
          <mat-icon matChipAvatar>event_busy</mat-icon>
          Udløbet
        </mat-chip>
      </mat-chip-set>
    }
  </div>
  @if (!item().isAvailable) {
    <span class="basket-item__unavailable">{{ item().message ?? 'Ikke tilgængelig' }}</span>
  }
</div>
<div class="basket-item__right">
  @if (item().price > 0) {
    <span class="basket-item__price">{{ item().price }} kr.</span>
  }
  <button
    matIconButton
    type="button"
    aria-label="Handlinger"
    [matMenuTriggerFor]="itemMenu"
  >
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #itemMenu>
    <button mat-menu-item type="button" (click)="basket.removeBasketItem(item())">
      <mat-icon>delete_outline</mat-icon>
      <span>Fjern fra kurv</span>
    </button>
    @if (showRepeat()) {
      <button mat-menu-item type="button" (click)="repeat()">
        <mat-icon>repeat</mat-icon>
        <span>Gentag periode</span>
      </button>
    }
  </mat-menu>
</div>
